import { render, staticRenderFns } from "./PersonalRow.vue?vue&type=template&id=31d1086e"
import script from "./PersonalRow.vue?vue&type=script&lang=js"
export * from "./PersonalRow.vue?vue&type=script&lang=js"
import style0 from "./PersonalRow.vue?vue&type=style&index=0&id=31d1086e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports